import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Form, Input, notification,
} from 'antd';
import { useTranslation } from 'react-i18next';
import * as Auth from 'aws-amplify/auth';

import { generateNotificationFromCognitoError } from '../../utils/errorHelpers';
import { verificationState } from './state';

const VerificationForm = (props) => {
  const {
    attribute,
    attributeText,
    setState,
    state,
  } = props;
  const { t } = useTranslation();
  const initialState = verificationState.NOT_VERIFIED;
  const [form] = Form.useForm();

  const handleOnFinish = async ({ code }) => {
    try {
      setState(verificationState.VERIFICATION_REQUESTED);
      await Auth.confirmUserAttribute({
        userAttributeKey: attribute,
        confirmationCode: code,
      });
      setState(verificationState.VERIFIED);
      notification.success({
        message: t('settings.userInformation.change.info.success', { value: attributeText }),
        description: '',
      });
    } catch (err) {
      setState(initialState);
      notification.error(generateNotificationFromCognitoError(t, err));
    }
  };

  const hasErrors = () => form.getFieldsError().some(({ errors }) => errors.length > 0);

  return (
    <Form form={form} name="VerificationForm" onFinish={handleOnFinish}>
      <Form.Item
        label={t('settings.userInformation.change.verificationCode')}
        name="code"
        rules={[
          {
            required: true,
            message: t('settings.userInformation.change.error.required'),
          },
        ]}
      >
        <Input
          placeholder={t('settings.userInformation.change.verificationCode')}
          disabled={state !== initialState}
          data-testid="verification-input-field"
        />
      </Form.Item>
      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            loading={state === verificationState.VERIFICATION_REQUESTED}
            disabled={hasErrors() || state !== initialState}
            data-testid="verification-submit-button"
          >
            {t('common.button.verify')}
          </Button>
        )}
      </Form.Item>
    </Form>
  );
};

VerificationForm.displayName = 'VerificationForm';
VerificationForm.propTypes = {
  attribute: PropTypes.oneOf(['email', 'phone_number']).isRequired,
  attributeText: PropTypes.string.isRequired,
  setState: PropTypes.func.isRequired,
  state: PropTypes.oneOf(Object.keys(verificationState)).isRequired,
};

export default VerificationForm;
